import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import _ from "underscore";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import { ViedocDialogElement } from "../../../../secure/elements/ViedocReactElements";
import Loader from "../../shared/Loader/Loader";

const ViewArtifactDialog = ({ setViewArtifactObj }) => {
  const { t } = useTranslation();

  const { mileStoneViewHandler, mileStoneList, artifactLoading } = useSelector(
    (store) => store.template
  );

  const onHide = () => {
    setViewArtifactObj(false);
  };

  const renderBorder = () => {
    return <div className="bb-1"></div>;
  };

  const renderMilestoneHeader = () => {
    return (
      <header className="pl-10" slot="header">
        <p className="f21 sem-pri-color">{`${t("ADMIN.TEXT_VIEW")} ${t(
          "ADMIN.TEXT_ARTIFACT"
        )} ${t("ADMIN.TEXT_PROPERTIES")}`}</p>
      </header>
    );
  };

  const renderCertification = () => {
    return (
      <section className="d-flex bb-1 pt-20 pl-30 pb-20">
        <div className="folder-icon">
          <viedoc-icon name="artifacts"></viedoc-icon>
        </div>
        {renderMilestoneViewHandler()}
      </section>
    );
  };

  const renderMilestoneViewHandler = () => {
    return (
      <div className="pl-10 popup-header">
        <p className="sem-pri-color f24">
          {mileStoneViewHandler?.classification?.artifactname}
        </p>
        <span className="f14 gray-60">
          {t("ADMIN.TEXT_FROMTEMPLATE")}
          {` ${UtilsHelper.fileExtensionRemoval(
            mileStoneViewHandler?.filename ? mileStoneViewHandler?.filename : ""
          )}`}
        </span>
      </div>
    );
  };

  const renderClassification = () => {
    if (mileStoneViewHandler) {
      const { classification } = mileStoneViewHandler;
      return (
        <section className="view-artifact-block">
          <article className="sem-pri-color">
            {t("ADMIN.TEXT_CLASSIFICATIONLBL")}
          </article>
          <aside className="d-flex flex-dir-col">
            <div className="pt-10">
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_ARTIFACT")}
                </div>
                <div className="w-70 pl-10 sem-pri-color">
                  {classification.artifactid || "-"}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_ARTIFACTNAME")}
                </div>
                <div className="w-70 pl-10 sem-pri-color">
                  {classification.artifactname || "-"}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_DEFINITION")}
                </div>
                <div className="w-70 pl-10 sem-pri-color">
                  {classification.definition || "-"}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_UNIQUEID")}
                </div>
                <div className="w-70 pl-10 sem-pri-color">
                  {classification.uniqueidnumber === "0" ||
                  !classification.uniqueidnumber
                    ? "-"
                    : classification.uniqueidnumber}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_SUBARTIFACTS")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_5">
                  {classification.subartifacts
                    ? classification.subartifacts.map((item, index) => (
                        <React.Fragment key={index}>
                          {item}
                          {index !== classification.subartifacts.length - 1 && (
                            <>
                              {", "}
                              <br />
                            </>
                          )}
                        </React.Fragment>
                      ))
                    : "-"}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.TEXT_TMFSIDE")}
                </div>
                <div className="w-70 pl-10 sem-pri-color">
                  {classification.possession
                    ? classification.possession.map((item, index) => (
                        <React.Fragment key={index}>
                          {item}
                          {index !== classification.possession.length - 1 && (
                            <>{", "}</>
                          )}
                        </React.Fragment>
                      ))
                    : "-"}
                </div>
              </div>
            </div>
          </aside>
        </section>
      );
    }
  };

  const returnMileStone = (mileStoneId) => {
    const findObject = _.find(mileStoneList, { id: mileStoneId });
    return !_.isEmpty(findObject) ? findObject.name : "-";
  };

  const renderTrialLevelSetting = () => {
    if (mileStoneViewHandler) {
      const { triallevelsetting } = mileStoneViewHandler;

      return (
        <section className="view-artifact-block">
          <article className="sem-pri-color">
            {`${t("ADMIN.TEXT_TRIAL")} ${t("ADMIN.TEXT_LEVELSETTINGS")}`}
          </article>
          <aside className="d-flex flex-dir-col">
            <div className="pt-10">
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("COMMON.TEXT_DOCUMENT")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_3">
                  <p>{triallevelsetting.document || "-"}</p>
                </div>
              </div>
              {triallevelsetting.document !== "Not permitted" && (
                <>
                  <div className="d-flex pad-10">
                    <div className="w-25 text-right pr-10 gray-60">
                      {`${t("ADMIN.ADMINTAB_ROLES")} ${t("TMF.TEXT_AND")} ${t(
                        "ADMIN.ADMINTAB_ACCESSES"
                      )}`}
                    </div>
                    <div className="w-70 pl-10 sem-pri-color lh1_3">
                      {triallevelsetting.rolesaccesses !== null
                        ? [
                            "SITESTAFF",
                            "SPONSOR-STUDY",
                            "SPONSOR-COUNTRY",
                            "SPONSOR-SITE",
                            "SPONSOR-REVIEW",
                            "SPONSOR-DM",
                            "SPONSOR-UNBLINDED",
                          ].map((role) => {
                            const roleaccess =
                              triallevelsetting.rolesaccesses.filter(
                                (roleaccess) =>
                                  roleaccess.name.replace("Role", "").trim() ===
                                  role
                              );
                            return (
                              <div className="role-access">
                                {roleaccess[0] &&
                                  roleaccess[0].name &&
                                  roleaccess[0].name.replace("Role", "")}
                                {!_.isEmpty(roleaccess[0].access) ? ", " : ""}
                                {!_.isEmpty(roleaccess[0].access)
                                  ? commaSeparatedValues(roleaccess[0].access)
                                  : "-"}
                              </div>
                            );
                          })
                        : "-"}
                    </div>
                  </div>

                  <div className="d-flex pad-10">
                    <div className="w-25 text-right pr-10 gray-60">
                      {t("ADMIN.ADMINTAB_MILESTONE")}
                    </div>
                    <div className="w-70 pl-10 sem-pri-color lh1_3">
                      <p> {returnMileStone(triallevelsetting.milestone)}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </aside>
        </section>
      );
    }
  };

  const renderCountryLevelSetting = () => {
    if (mileStoneViewHandler) {
      const { countrylevelsetting } = mileStoneViewHandler;
      return (
        <section className="view-artifact-block">
          <article className="sem-pri-color">
            {`${t("ADMIN.TEXT_COUNTRYLBL")} ${t("ADMIN.TEXT_LEVELSETTINGS")}`}
          </article>
          <aside className="d-flex flex-dir-col">
            <div className="pt-10">
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("COMMON.TEXT_DOCUMENT")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_3">
                  {countrylevelsetting.document || "-"}
                </div>
              </div>
              {countrylevelsetting.document !== "Not permitted" && (
                <>
                  <div className="d-flex pad-10">
                    <div className="w-25 text-right pr-10 gray-60">
                      {`${t("ADMIN.ADMINTAB_ROLES")} ${t("TMF.TEXT_AND")} ${t(
                        "ADMIN.ADMINTAB_ACCESSES"
                      )}`}
                    </div>
                    <div className="w-70 pl-10 sem-pri-color lh1_3">
                      {countrylevelsetting.rolesaccesses !== null
                        ? [
                            "SITESTAFF",
                            "SPONSOR-STUDY",
                            "SPONSOR-COUNTRY",
                            "SPONSOR-SITE",
                            "SPONSOR-REVIEW",
                            "SPONSOR-DM",
                            "SPONSOR-UNBLINDED",
                          ].map((role) => {
                            const roleaccess =
                              countrylevelsetting.rolesaccesses.filter(
                                (roleaccess) =>
                                  roleaccess.name.replace("Role", "").trim() ===
                                  role
                              );
                            return (
                              <div className="role-access">
                                {roleaccess[0] &&
                                  roleaccess[0].name &&
                                  roleaccess[0].name.replace("Role", "")}
                                {!_.isEmpty(roleaccess[0].access) ? ", " : ""}
                                {!_.isEmpty(roleaccess[0].access)
                                  ? commaSeparatedValues(roleaccess[0].access)
                                  : "-"}
                              </div>
                            );
                          })
                        : "-"}
                    </div>
                  </div>
                  <div className="d-flex pad-10">
                    <div className="w-25 text-right pr-10 gray-60">
                      {t("ADMIN.ADMINTAB_MILESTONE")}
                    </div>
                    <div className="w-70 pl-10 sem-pri-color lh1_3">
                      {" "}
                      {returnMileStone(countrylevelsetting.milestone)}
                    </div>
                  </div>
                </>
              )}
            </div>
          </aside>
        </section>
      );
    }
  };

  const renderSiteLevelSetting = () => {
    if (mileStoneViewHandler) {
      const { sitelevelsetting } = mileStoneViewHandler;
      return (
        <section className="view-artifact-block">
          <article className="sem-pri-color">
            {`${t("ADMIN.TEXT_SITELBL")} ${t("ADMIN.TEXT_LEVELSETTINGS")}`}
          </article>
          <aside className="d-flex flex-dir-col">
            <div className="pt-10">
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("COMMON.TEXT_DOCUMENT")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_3">
                  {sitelevelsetting.document}
                </div>
              </div>
              {sitelevelsetting.document !== "Not permitted" && (
                <>
                  <div className="d-flex pad-10">
                    <div className="w-25 text-right pr-10 gray-60">
                      {`${t("ADMIN.ADMINTAB_ROLES")} ${t("TMF.TEXT_AND")} ${t(
                        "ADMIN.ADMINTAB_ACCESSES"
                      )}`}
                    </div>
                    <div className="w-70 pl-10 sem-pri-color lh1_3">
                      {sitelevelsetting.rolesaccesses !== null
                        ? [
                            "SITESTAFF",
                            "SPONSOR-STUDY",
                            "SPONSOR-COUNTRY",
                            "SPONSOR-SITE",
                            "SPONSOR-REVIEW",
                            "SPONSOR-DM",
                            "SPONSOR-UNBLINDED",
                          ].map((role) => {
                            const roleaccess =
                              sitelevelsetting.rolesaccesses.filter(
                                (roleaccess) =>
                                  roleaccess.name.replace("Role", "").trim() ===
                                  role
                              );
                            return (
                              <div className="role-access">
                                {roleaccess[0] &&
                                  roleaccess[0].name &&
                                  roleaccess[0].name.replace("Role", "")}
                                {!_.isEmpty(roleaccess[0].access) ? ", " : ""}
                                {!_.isEmpty(roleaccess[0].access)
                                  ? commaSeparatedValues(roleaccess[0].access)
                                  : "-"}
                              </div>
                            );
                          })
                        : "-"}
                    </div>
                  </div>
                  <div className="d-flex pad-10">
                    <div className="w-25 text-right pr-10 gray-60">
                      {t("ADMIN.ADMINTAB_MILESTONE")}
                    </div>
                    <div className="w-70 pl-10 sem-pri-color lh1_3">
                      {returnMileStone(sitelevelsetting.milestone)}
                    </div>
                  </div>
                </>
              )}
            </div>
          </aside>
        </section>
      );
    }
  };
  const commaSeparatedValues = (values = []) => {
    return !_.isEmpty(values) ? values.join(", ") : "";
  };

  const getSharingData = (sharing) => {
    if (_.isEmpty(sharing)) {
      return "-";
    }
    if (sharing?.clinicaluser?.enable && sharing?.subjectuser?.enable) {
      return `${t("TMF.TEXT_VIEDOCCLINICALUSERS")}, ${t(
        "ADMIN.ADMINTAB_VIEDOCMEUSERS"
      )}`;
    } else if (sharing?.clinicaluser?.enable && !sharing?.subjectuser?.enable) {
      return t("TMF.TEXT_VIEDOCCLINICALUSERS");
    } else if (sharing?.subjectuser?.enable && !sharing?.clinicaluser?.enable) {
      return t("ADMIN.ADMINTAB_VIEDOCMEUSERS");
    } else if (
      !sharing?.subjectuser?.enable &&
      !sharing?.clinicaluser?.enable
    ) {
      return "-";
    }
  };

  const renderSharingInfo = () => {
    const { sharing } = mileStoneViewHandler;
    return (
      <section className="view-artifact-block">
        <article className="sem-pri-color">
          {t("ADMIN.ADMINTAB_SHARING")}
        </article>
        <aside className="d-flex flex-dir-col">
          <div className="pt-10">
            <div className="d-flex pad-10">
              <div className="w-25 text-right pr-10 gray-60">
                {t("TMF.TEXT_ENABLEFOR")}
              </div>
              <div className="w-70 pl-10 sem-pri-color lh1_3">
                {getSharingData(sharing)}
              </div>
            </div>
          </div>
        </aside>
      </section>
    );
  };

  const renderDetails = () => {
    if (mileStoneViewHandler) {
      const { detail } = mileStoneViewHandler;
      return (
        <section className="view-artifact-block">
          <article className="sem-pri-color">
            {t("ADMIN.ADMINTAB_DETAILS")}
          </article>
          <aside className="d-flex flex-dir-col">
            <div className="pt-10">
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_FILEFORMATS")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_3">
                  {detail.fileformats !== null
                    ? commaSeparatedValues(detail.fileformats)
                    : "-"}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_BLINDEDDATA")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_3">
                  {detail.blindeddata || "-"}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_PRIVACYDATA")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_3">
                  {detail.privaydata || "-"}
                </div>
              </div>
              <div className="d-flex pad-10">
                <div className="w-25 text-right pr-10 gray-60">
                  {t("ADMIN.ADMINTAB_DATINGCONVENTION")}
                </div>
                <div className="w-70 pl-10 sem-pri-color lh1_3">
                  {detail.datingconvention || "-"}
                </div>
              </div>
            </div>
          </aside>
        </section>
      );
    }
  };

  return artifactLoading ? (
    <ViedocDialogElement
      size="large"
      open
      preventCloseByClick
      id="view-artifact"
      class="view-artifact"
      onHide={() => onHide()}
    >
      {renderMilestoneHeader()}
      <main className="view-artifact-dialog">
        <Loader width={"100%"} height={"100%"} borderRadius />
      </main>
    </ViedocDialogElement>
  ) : (
    <ViedocDialogElement
      size="large"
      open
      preventCloseByClick
      id="view-artifact"
      class="view-artifact"
      onHide={() => onHide()}
    >
      {renderMilestoneHeader()}
      <main className="view-artifact-dialog">
        {renderCertification()}

        {renderClassification()}

        {renderBorder()}

        {renderTrialLevelSetting()}

        {renderBorder()}

        {renderCountryLevelSetting()}

        {renderBorder()}

        {renderSiteLevelSetting()}

        {renderBorder()}
        {renderDetails()}
        {renderSharingInfo()}
      </main>
    </ViedocDialogElement>
  );
};

export default ViewArtifactDialog;
